__turbopack_context__.v({
  "bullet": "BMjqIa_bullet",
  "bulletListContainer": "BMjqIa_bulletListContainer",
  "itemsContainer": "BMjqIa_itemsContainer",
});
